import AppButton from "../../components/common/AppButton";
import AppForm from "../../components/common/AppForm";
import AppLoader from "../../components/common/AppLoader";
import { resetPassword } from "../../services";
import { useAsync } from "../../hooks";
import { ResetPasswordData } from "../../interface";
import { resetPasswordSchema } from "../../utils";
import { resetPasswordFields } from "../../constants";

import { useLocation, useNavigate } from "react-router-dom";

const ResetPassword = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const token = query.get("token");

  const { loading, execute } = useAsync<string, [ResetPasswordData]>();

  if (!token) {
    return <p>Invalid or missing token.</p>;
  }

  const handleSubmit = async (values: {
    password: string;
    confirmPassword: string;
  }) => {
    try {
      await execute(resetPassword, { token, password: values.password });
      alert("Password reset successful! Please log in.");
      navigate("/login");
    } catch {
      alert("Failed to reset password.");
    }
  };

  return (
    <div
      className="container mt-5"
      style={{ position: "relative", minHeight: "200px" }}
    >
      {loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <AppLoader />
        </div>
      )}
      <h2>Reset Your Password</h2>
      <AppForm
        inputFields={resetPasswordFields}
        initialValues={{ password: "", confirmPassword: "" }}
        schema={resetPasswordSchema}
        handleSubmit={handleSubmit}
      >
        {({ isSubmitting, isValid }) => (
          <AppButton
            label="Reset Password"
            size="sm"
            fullWidth={false}
            disabled={isSubmitting || !isValid}
          />
        )}
      </AppForm>
    </div>
  );
};

export default ResetPassword;
